import React from "react";
import WomenEntryToPrisoner from "./WomenEntryToPrisoner";
import WomenIncarceration from "./WomenIncarceration";
import WomenCom from "./WomenCom";
import WomenTimeline from "./WomenTimeline";
import WomenVoicenotes from "./WomenVoicenotes";
import WomenPrisonStatistics from "./WomenPrisonStatistics";

function WomenIndex() {
  return (
    <div className="border-bottom-style">
      <div className="bg-women-img">
        <div className="container">
          <WomenCom />
          <WomenTimeline />
        </div>
        <div>
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/bgcrop.png")}
            alt="bgcrop"
          />
        </div>
      </div>
      <div className="">
        {/* <div className="container">
          <WomenVoicenotes />
        </div>
        <div>
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/voice2.png")}
            alt="voice2"
          />
        </div> */}
        <div className="container">
          <WomenVoicenotes />
          <div>
            <img
              style={{ width: "100%", height: "100%" }}
              src={require("../../assets/images/voice2.png")}
              alt="voice2"
            />
          </div>
          <WomenIncarceration />
          <WomenPrisonStatistics />
        </div>
      </div>
      <WomenEntryToPrisoner />
    </div>
  );
}

export default WomenIndex;
